import { required, helpers, maxLength, minLength, numeric, email } from "@vuelidate/validators";

// Regex Patterns
const Numeric_SpecialChar = helpers.regex(/^[0-9 \\/-]*$/) // include numbers, spaces, - , /
const EgyMobilePattern = helpers.regex(/^01[0-2,5]{1}[0-9]{8}$/)


// Documents Validations
const Birth_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
    copies: { required: helpers.withMessage("*", required), $autoDirty: true },
}

const FirstBirth_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
}

const Death_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        relationCode: { required: helpers.withMessage("*", required), $autoDirty: true },
        
    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
    copies: { required: helpers.withMessage("*", required), $autoDirty: true },
}

const Marriage_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        spouseName: { required: helpers.withMessage("*", required), $autoDirty: true },
        relationCode: { required: helpers.withMessage("*", required), $autoDirty: true },
        
    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
    copies: { required: helpers.withMessage("*", required), $autoDirty: true },
}


const FamilyRecord_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        destination: { required: helpers.withMessage("*", required), $autoDirty: true },
        relationCode: { required: helpers.withMessage("*", required), $autoDirty: true },
        
    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
    copies: { required: helpers.withMessage("*", required), $autoDirty: true },
}

const PersonalRecord_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        
    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
    copies: { required: helpers.withMessage("*", required), $autoDirty: true },
}

const NID_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        gender: { required: helpers.withMessage("*", required), $autoDirty: true },
        issueReason:{ required:helpers.withMessage("*", required), $autoDirty: true  },   
    },
}


const NidForm_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        gender: { required: helpers.withMessage("*", required), $autoDirty: true },    
    },
    documentType:{ required:helpers.withMessage("*", required), $autoDirty: true  }, 
}

// Translated Documents validations

const TBirth_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        languageCode: { required: helpers.withMessage("*", required), $autoDirty: true },
    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
    copies: { required: helpers.withMessage("*", required), $autoDirty: true },
}



const TDeath_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        relationCode: { required: helpers.withMessage("*", required), $autoDirty: true },
        languageCode: { required: helpers.withMessage("*", required), $autoDirty: true },
    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
    copies: { required: helpers.withMessage("*", required), $autoDirty: true },
}


const TMarriage_validations = {
    form: {
        firstName: {  required:helpers.withMessage("*", required), $autoDirty: true } ,
        secondName:{ required:helpers.withMessage("*", required), $autoDirty: true  },
        thirdName:{ required:helpers.withMessage("*", required), $autoDirty: true  },
        fourthName:{ required:helpers.withMessage("*", required), $autoDirty: true  },
        nid:{ required:helpers.withMessage("*", required), 
                maxLength:helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم",maxLength(14)),
                minLength:helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم",minLength(14)),
                numeric:helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
                $autoDirty: true },
        motherName:{ required:helpers.withMessage("*", required), $autoDirty: true  },
        spouseName:{ required:helpers.withMessage("*", required), $autoDirty: true  },
        relationCode:{ required:helpers.withMessage("*", required), $autoDirty: true  },
        languageCode:{ required:helpers.withMessage("*", required), $autoDirty: true  },
    },
    gender:{ required:helpers.withMessage("*", required), $autoDirty: true },
    copies:{ required:helpers.withMessage("*", required), $autoDirty: true }
}



const TFamilyRecord_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        languageCode: { required: helpers.withMessage("*", required), $autoDirty: true },
        // destination: { required: helpers.withMessage("*", required), $autoDirty: true },

    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
    copies: { required: helpers.withMessage("*", required), $autoDirty: true }
}

const TPersonalRecord_validations = {
    form: {
        firstName: { required: helpers.withMessage("*", required), $autoDirty: true },
        secondName: { required: helpers.withMessage("*", required), $autoDirty: true },
        thirdName: { required: helpers.withMessage("*", required), $autoDirty: true },
        fourthName: { required: helpers.withMessage("*", required), $autoDirty: true },
        nid: {
            required: helpers.withMessage("*", required),
            maxLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", maxLength(14)),
            minLength: helpers.withMessage("هذا الحقل يجب أن يكون 14 رقم", minLength(14)),
            numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),
            $autoDirty: true
        },
        motherName: { required: helpers.withMessage("*", required), $autoDirty: true },
        languageCode: { required: helpers.withMessage("*", required), $autoDirty: true },
    },
    gender: { required: helpers.withMessage("*", required), $autoDirty: true },
    copies: { required: helpers.withMessage("*", required), $autoDirty: true }
}


// Review Request Validations
const Review_validations  = {
    form: {
        postalCode: { required: helpers.withMessage("*", required), $autoDirty: true },
        policeCode: { required: helpers.withMessage("*", required), $autoDirty: true },
        //  رقم الشقة
        departmentNo: { required: helpers.withMessage("*", required), $autoDirty: true ,
                        Numeric_SpecialChar: helpers.withMessage("هذا الحقل يجب أن يحتوى على 'أرقام' أو  '-' ، '/' إذا كان فارغا", Numeric_SpecialChar)
                    },
        floorNo: { required: helpers.withMessage("*", required), $autoDirty: true ,
                    numeric: helpers.withMessage("هذا الحقل يجب أن يحتوى على أرقام", numeric),},
        
        // رقم المنزل
        flatNo: { required: helpers.withMessage("*", required), $autoDirty: true},
        streetName: { required: helpers.withMessage("*", required), $autoDirty: true },
        districtName: { required: helpers.withMessage("*", required), $autoDirty: true },
        detailedAddress: { required: helpers.withMessage("*", required), $autoDirty: true },
        mobile1: {
            required: helpers.withMessage("*", required),
            EgyMobilePattern: helpers.withMessage("يجب ان يحتوى على 11 رقم ويبدأ ب 010 أو 011 أو 012 أو 015",EgyMobilePattern),
            $autoDirty: true
        },
        mobile2: {
            required: helpers.withMessage("*", required),
            EgyMobilePattern: helpers.withMessage("يجب ان يحتوى على 11 رقم ويبدأ ب 010 أو 011 أو 012 أو 015",EgyMobilePattern),
            $autoDirty: true
        },
        
       
    },
    govCode: { required: helpers.withMessage("*", required), $autoDirty: true },
}

const Complains_validations  = {
    form: {
        name: { required: helpers.withMessage("*", required), $autoDirty: true},
        typeId: { required: helpers.withMessage("*", required), $autoDirty: true},
        message: { required: helpers.withMessage("*", required), $autoDirty: true},
        email: {    
            required: helpers.withMessage("*", required),
            email: helpers.withMessage('example@example.com', email),
            $autoDirty: true},
        mobile: {
            required: helpers.withMessage("*", required),
            EgyMobilePattern: helpers.withMessage("يجب ان يحتوى على 11 رقم ويبدأ ب 010 أو 011 أو 012 أو 015",EgyMobilePattern),
            $autoDirty: true
        }
    },
}

export default {
                // Documents
                Birth: Birth_validations, 
                FirstBirth: FirstBirth_validations,
                Death: Death_validations,
                Marriage: Marriage_validations,
                Divorce: Marriage_validations,
                FamilyRecord: FamilyRecord_validations,
                PersonalRecord: PersonalRecord_validations,
                NID: NID_validations,
                NidForm: NidForm_validations,

                //translated Docs

                TBirth: TBirth_validations,
                TDeath: TDeath_validations,
                TMarraige: TMarriage_validations,
                TDivorce: TMarriage_validations,
                TFamilyRecord: TFamilyRecord_validations,
                TPersonalRecord: TPersonalRecord_validations,

                // Review Request
                Review: Review_validations,
                Complains: Complains_validations
                
               }